import { Link } from 'react-router-dom';
import React from 'react';
import chennai from './componets.js/WhatsApp Image 2025-06-16 at 03.17.51_01c04162.jpg';
import mumbai from './componets.js/WhatsApp Image 2025-06-16 at 03.17.52_0cc194bf.jpg';
import delhi from './componets.js/WhatsApp Image 2025-06-16 at 03.17.52_7c72426b.jpg';
import goa from './componets.js/WhatsApp Image 2025-06-16 at 16.31.21_7bb089e3.jpg';
import findmore from './componets.js/WhatsApp Image 2025-06-16 at 16.32.27_8e62a284.jpg';
import './city.css';

export const City = () => {
  return (
    <>
    <h1 style={{color:" #ff385c",
    display:"flex",
      justifyContent:"center"
    }}>STAYFINDER</h1>
   
  
  
    <div className="city-container">
      
      <Link to="/goa" className="stayfinder-link">
        <img src={goa} alt="Goa Hotels" className="stayfinder-link-img" />
        <div className="city-label"></div>
      </Link>
      <Link to="/chennai" className="stayfinder-link">
        <img src={chennai} alt="Chennai Hotels" className="stayfinder-link-img" />
        <div className="city-label"></div>
      </Link>
      <Link to="/delhi" className="stayfinder-link">
        <img src={delhi} alt="Delhi Hotels" className="stayfinder-link-img" />
        <div className="city-label">Delhi</div>
      </Link>
      <Link to="/mumbai" className="stayfinder-link">
        <img src={mumbai} alt="Mumbai Hotels" className="stayfinder-link-img" />
        <div className="city-label"></div>
      </Link>
      <Link to="/search" className="stayfinder-link">
        <img src={findmore} alt="Find More" className="stayfinder-link-img" />
        <div className="city-label"></div>
      </Link>
    </div>
     <Link className='ra' to='/'>Back</Link>
    </>
  );
};
